import {clickEvent, customEvent, fireClickEvent, mouseLeaveElementEvent} from "../../webpack/modules/events";
import {sendEmail, showPopup} from "../../webpack/modules-optimized/popup-smarter-click";
import {sendPopupEvent} from "../../../library/analytics";
import {getModal} from "../../webpack/modules-optimized/modal";
import {applyVoucher} from "../../webpack/modules-optimized/voucher";
import {hideLoader, renderCart, showLoader} from "../../webpack/modules-optimized/cart";
import {isMobile, isTablet} from "../../webpack/modules/devices";

setTimeout(function () {
    mouseLeaveElementEvent(document, function(element, event) {
        let productFinder = document.getElementById('product-finder');
        if (productFinder && productFinder.classList.contains('pf-open')) return;
        let windowHeight = window.innerHeight;
        if (event.offsetY < 0 || event.offsetY >= windowHeight) showPopup();
    });

    if (isTablet() || isMobile()) {
        window.addEventListener('blur', function(){
            let productFinder = document.getElementById('product-finder');
            if (productFinder && productFinder.classList.contains('pf-open')) return;
            showPopup();
        });
    }
}, 30000); // wait 30s before show any popup for the first time

clickEvent('.close-pop-up-smarter-click', true, function(element) {
    let popupAction = element.dataset.popupType || 'pop-up';
    sendPopupEvent('popup_discount', popupAction, 'cancel');
});

clickEvent('#pop-up-smarter-click-email', true, function(element) {
    document.getElementById('pop-up-smarter-click-email').classList.remove('error');
});

clickEvent('#pop-up-smarter-click-privacy, #pop-up-smarter-click-privacy-container', true, function(element) {
    document.getElementById('pop-up-smarter-click-privacy-container').classList.remove('error');
});

clickEvent('#approve-pop-up-smarter-click', true, async function(element) {
    let popupAction = element.dataset.popupType || 'pop-up';
    let popupType = document.getElementById('pop-up-smarter-click').value;
    let privacyElement = document.getElementById('pop-up-smarter-click-privacy');
    let privacyElementContainer = document.getElementById('pop-up-smarter-click-privacy-container');
    let email = document.getElementById('pop-up-smarter-click-email');
    let cart = document.getElementById('cart');
    let error = false;

    email.classList.remove('error');
    if (!validateEmail(email.value)) {
        email.classList.add('error');
        error = true;
    }

    privacyElementContainer.classList.remove('error');
    if (!privacyElement.checked) {
        privacyElementContainer.classList.add('error');
        error = true;
    }
    if (error) {
        return;
    }


    sendEmail(email, popupType);
    getModal('modal-pop-up-smarter-click').hide();

    sendPopupEvent('popup_discount', popupAction, 'approve');
});

customEvent('hidden.bs.modal', '#modal-pop-up-smarter-click', true, function() {
    document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
});

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}
